import {FC} from 'react';
import clsx from 'clsx';
import {Controller} from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import s from './styles.module.scss';

const FormPhoneInput: FC<any> = ({
  className,
  label,
  labelClassName,
  name,
  country,
  control,
  rules,
  error,
  disabled,
  onChange,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({field}) => (
      <div className={s['phone-control']}>
        {label && <div className={clsx(s['phone-control__label'], labelClassName)}>{label}</div>}
        <PhoneInput
          country={country || 'us'}
          containerClass={clsx(s['phone-control__input'], className)}
          value={field.value}
          disabled={disabled}
          onChange={(value) => {
            field.onChange(value);

            if (onChange) {
              onChange(value);
            }
          }}
          {...rest}
        />
        {error && <div className={s['phone-control__error']}>{error}</div>}
      </div>
    )}
  />
);

export default FormPhoneInput;
